// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__RCSLb","footer":"ModalUpdate_footer__1kdx3"};